import React from "react"
import bg_contact from "../assets/new_img/contact-background2.jpg";

const Footer = ({ menus }) => {
    return (
        <section id="footer-content">
            <section 
                className="section section-text-light section-background m-0"
                style={{ background: `url(${bg_contact})`, backgroundSize: "cover" }}>
                <div className="container">
                    <div className="row justify-content-md-center text-center">
                        <div className="col-lg-12 custom-sm-margin-top">
                        <h2 className="font-weight-bold awards-title">
                            <font color="black">Award & Certification</font>
                        </h2>
                        </div>
                    </div>
                   <div className="awards-logos">
                        <img className="logo-award logo-award-1" src="itr2025.jpeg" alt="Award 2025" />
                        <img className="logo-award logo-award-2" src="tp2024.png" alt="Award 2024" />
                        <img className="logo-award logo-award-3" src="itr2026.png" alt="Award 2026" />
                    </div>
                </div>
            </section>
            <footer id="footer">
                <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center pb-4">
                    <p className="font-white">{new Date().getFullYear()} © <span className="text-color-light">Pro Visioner</span> - Copyright All Rights Reserved</p>
                    </div>
                </div>
                </div>
            </footer>
        </section>
    )
}

export default Footer;